const DialogTypes = {
    Account: async () => (await import("@/Data/Account/AccountDialog")).AccountDialog,
    AccountGroup: async () => (await import("@/Data/AccountGroup/AccountGroupDialog")).AccountGroupDialog,
    Security: async () => (await import("@/Data/Security/SecurityDialog")).SecurityDialog,
    SecurityInternal: async () => (await import("@/Data/SecurityInternal/SecurityInternalDialog")).SecurityInternalDialog,
    Party: async () => (await import("@/Data/Party/PartyDialog")).PartyDialog
}

export default DialogTypes;